import { Icon, makeIconsString } from "utils/Icon"

const RedMarker = () => {
  return (
    <Icon
      role="presentation"
      id="#water-outage-current"
      width="100%"
      height="100%"
    />
  )
}

export const redMarkerString = makeIconsString(RedMarker)

export default RedMarker
